import {
  CalendarEventType,
  CreateCalendarEventDto,
  PatchCalendarEventDto,
} from '@mommy/models/CalendarEventInfo.model';

/** 載入指定日期區間的行事曆事件（行事曆月份切換時呼叫） */
export class LoadEventsByRange {
  static readonly type = '[Reminder] LoadEventsByRange';
  constructor(
    public from: string, // YYYY-MM-DD
    public to: string, // YYYY-MM-DD
    public event_type?: CalendarEventType,
    public silent = false // true：背景載入（如首頁角標），失敗不跳錯誤 toast
  ) {}
}

/** 取得單筆事件詳情 */
export class GetEventDetail {
  static readonly type = '[Reminder] GetEventDetail';
  constructor(public eventId: number) {}
}

/** 新增單筆事件 */
export class CreateEvent {
  static readonly type = '[Reminder] CreateEvent';
  constructor(public dto: CreateCalendarEventDto) {}
}

/** 一次新增多筆事件（慢箋多次領藥：各期一筆） */
export class CreateEventsBatch {
  static readonly type = '[Reminder] CreateEventsBatch';
  constructor(public dtos: CreateCalendarEventDto[]) {}
}

/** 更新事件 */
export class UpdateEvent {
  static readonly type = '[Reminder] UpdateEvent';
  constructor(public eventId: number, public dto: PatchCalendarEventDto) {}
}

/** 刪除事件 */
export class DeleteEvent {
  static readonly type = '[Reminder] DeleteEvent';
  constructor(public eventId: number) {}
}
